import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (params) => {
  return axios.get(process.env.REACT_APP_API_URL + "user/list", {
    headers: authHeader(),
    data: {},
    params
  });
};

const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `user/view/${id}`, {
    headers: authHeader(),
    data: {},
  });
};

const create = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + `user/create`, data, {
    headers: authHeader(),
  });
};

const createstoreadmin = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + `user/shopadmin/create`, data, {
    headers: authHeader(),
  });
};


const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `user/update/${id}`, data, {
    headers: authHeader(),
  });
};

const updateprofile = (data) => {
  return axios.put(process.env.REACT_APP_API_URL + `profile`, data, {
    headers: multipartHeader(),
  });
};

const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `user/updateStatus/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};

const deleteUser = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `user/delete/${id}`, {
    headers: authHeader(),
    data
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `user/restore/${id}`, {
    headers: authHeader(),
    params: data
  });
};

const makeStoreAdmin = (data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + "user/makeStoreAdmin",
    data,
    { headers: authHeader() }
  );
};

export default {
  getAll,
  get,
  create,
  createstoreadmin,
  update,
  updateprofile,
  updateStatus,
  deleteUser,
  restore,
  makeStoreAdmin,
};
